import { LoadingButton } from '@mui/lab'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material'
import { snackBarVisibleVar } from 'context'
import { IModalProps } from 'hooks'
import { startCase } from 'lodash-es'
import { Controller, useForm } from 'react-hook-form'
import {
  SensorModelsSupportedModelsKind,
  useCurrentUserQuery,
  useUpdateSupportedSensorMutation
} from 'types'

interface IUpdateSupportedSensorForm {
  model: SensorModelsSupportedModelsKind
}

export const UpdateSupportedSensorDialog = ({ closeModal, modalState }: IModalProps) => {
  const { data: { currentUser } = {}, refetch } = useCurrentUserQuery()

  const { handleSubmit, control } = useForm<IUpdateSupportedSensorForm>({
    mode: 'onTouched',
    defaultValues: {
      model: Object.values(SensorModelsSupportedModelsKind)[0]
    }
  })

  const [updateSupportedSensor, { loading }] = useUpdateSupportedSensorMutation({
    onError: (error) =>
      snackBarVisibleVar({
        open: true,
        message: error.message
      }),
    onCompleted: () => {
      closeModal()
      refetch()
    }
  })

  const updateSupportedSensorHandler = async (formData: IUpdateSupportedSensorForm) => {
    if (!currentUser) {
      return
    }

    await updateSupportedSensor({
      variables: { model: formData.model }
    })
  }

  return (
    <Dialog maxWidth="xs" fullWidth open={modalState} onClose={closeModal}>
      <form onSubmit={handleSubmit(updateSupportedSensorHandler)}>
        <DialogTitle>Update Member Supported Sensor</DialogTitle>
        <DialogContent>
          <FormControl variant="standard" margin="dense" fullWidth>
            <InputLabel required id="sensor-model-label">
              Sensor Model
            </InputLabel>
            <Controller
              control={control}
              name="model"
              render={({ field: { onChange, ref, value } }) => {
                return (
                  <Select
                    labelId="model-label"
                    label="Model"
                    onChange={onChange}
                    value={value}
                    ref={ref}
                  >
                    {Object.values(SensorModelsSupportedModelsKind).map((model) => (
                      <MenuItem key={model} value={model}>
                        {startCase(model)}
                      </MenuItem>
                    ))}
                  </Select>
                )
              }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal}>Cancel</Button>
          <LoadingButton type="submit" loading={loading}>
            Change Supported Sensor
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}
